/**
 * Centralised socket event name constants.
 * Import from here instead of using raw strings so that renaming
 * a channel is a single-line change and typos become compile errors.
 */
export const GameEvents = {
	/** Host → clients: broadcast updated registry state */
	REGISTRY_SYNC: "state.registry:sync",
	/** Client → host: submit a score (round-based and live-scoring games) */
	UPDATE_SCORE: "game:updateScore",
	/** Host → clients: advance to the next round */
	NEXT_ROUND: "game:nextRound",
	/** Client → host: circleRider click event */
	CIRCLE_CLICK: "game:circleClick",
} as const;

export type GameEventName = (typeof GameEvents)[keyof typeof GameEvents];
